module.exports = __webpack_public_path__ + "static/img/1.4041aff2.png";